import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from '../../contexts/auth.provider';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children, requireAuth = true, redirectTo}) => {
  const {isAuthenticated, isLoading} = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to={redirectTo || '/dashboard'} replace />;
  }

  return <>{children}</>;
};
